import React, { useState, createContext, useContext } from "react";
interface IUserContext {
  isAuthorize: boolean;
  setIsAuthorize: React.Dispatch<React.SetStateAction<IUserContext["isAuthorize"]>>;
  isLoadingLandingPage: boolean;
  setIsLoadingLandingPage: React.Dispatch<React.SetStateAction<IUserContext["isLoadingLandingPage"]>>;
  role: "user"|"super_user"|"admin";
  setRole: React.Dispatch<React.SetStateAction<IUserContext["role"]>>;
}

const userContext = createContext<any>(null);

export const UserContextProvider = ({children}: React.PropsWithChildren<{}>) => {
  const [isAuthorize, setIsAuthorize] = useState<IUserContext["isAuthorize"]>(false);
  const [isLoadingLandingPage, setIsLoadingLandingPage] = useState<IUserContext["isLoadingLandingPage"]>(false);
  const [role, setRole] = useState<IUserContext["role"]>("user");

  return (
    <userContext.Provider value={{ isAuthorize, setIsAuthorize, isLoadingLandingPage, setIsLoadingLandingPage, role, setRole }}>
      {children}
    </userContext.Provider>
  );
};

export const useUser = () => {
  const { isAuthorize, setIsAuthorize, isLoadingLandingPage, setIsLoadingLandingPage, role, setRole } = useContext(userContext);
  return { isAuthorize, setIsAuthorize, isLoadingLandingPage, setIsLoadingLandingPage, role, setRole };
};
